﻿import { ajaxGet, ajaxPost } from '../../utils/ajax';

export default {
    createHardwarePaymentAsync(params, callback, errorCallback) {
        var itemDiscounts = JSON.stringify((params.discount != 0) ? params.discounts : {});
        var url = "/teliadk/OrderItemsCreditAccountBlock/CreateHardwarePaymentAsync?orderID=" + params.orderId + "&subscriptionId=" + params.subscriptionId + "&itemDiscounts=" + itemDiscounts;
        ajaxPost(url, createHardwarePaymentDTO(params))
            .then(callback)
            .catch(errorCallback);
    },
    updateHardwarePaymentAsync(params, callback, errorCallback) {
        var itemDiscounts = JSON.stringify((params.discount != 0) ? params.discounts : {});
        var url = "/teliadk/OrderItemsCreditAccountBlock/UpdateHardwarePaymentAsync?orderID=" + params.orderId + "&subscriptionId=" + params.subscriptionId + "&hardwarePaymentId=" + params.hardwarePaymentId + "&itemDiscounts=" + itemDiscounts;
        var dto = createHardwarePaymentDTO(params)
        ajaxPost(url, dto)
            .then(callback)
            .catch(errorCallback);
    },
    deleteHardwarePaymentAsync(orderId, subscriptionId, hardwarePaymentID, callback, errorCallback) {
        var url = "/teliadk/OrderItemsCreditAccountBlock/DeleteHardwarePaymentAsync?orderID=" + orderId + "&subscriptionId=" + subscriptionId + "&hardwarePaymentID=" + hardwarePaymentID;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);
    },
    createExternalPayment(orderId, params, callback, errorCallback) {
        var url = "/teliadk/CustomerOrderInfoCreditAccountBlock/CreateExternalPayment?orderID=" + orderId;
        ajaxPost(url, params)
            .then(callback)
            .catch(errorCallback);
    },
    getDiscountDetails(orderId, dealerCode, callback, errorCallback) {
        var url = "/teliadk/CustomerOrderInfoCreditAccountBlock/GetDiscountDetails?orderId=" + orderId + "&dealerCode=" + dealerCode;
        ajaxPost(url)
            .then(callback)
            .catch(errorCallback);
    },
    hardwarePaymentByOrderAsync(params, callback, errorCallback) {
        const url = "/teliadk/OrderItemsCreditAccountBlock/HardwarePaymentConfigurationAsync?orderID=" + params.orderId + "&dealerCode=" + params.dealerCode;
        var dto = hardwarePaymentDTO(params)
        ajaxPost(url, dto)
            .then(callback)
            .catch(errorCallback);
    },

}

function createHardwarePaymentDTO(params) {
    const parameters = {
        "discount": params.discount,
        "discounts": params.discounts,
        "downPayment.downPaymentAmount.currency": params.currency,
        "downPayment.downPaymentAmount.amount": params.downPaymentAmount,
        "downPayment.downPaymentAmount.VAT": params.downPaymentVAT,
        "downPayment.downPaymentId": params.downPaymentId,
        "downPayment.installmentAmount.currency": params.currency,
        "downPayment.installmentAmount.amount": params.downPaymentInstallmentAmount,
        "downPayment.installmentAmount.VAT": params.downPaymentInstallmentVAT,
        "downPayment.lastInstallmentAmount.currency": params.currency,
        "downPayment.lastInstallmentAmount.amount": params.downPaymentLastInstallmentAmount,
        "downPayment.lastInstallmentAmount.VAT": params.downPaymentLastInstallmentVAT,
        "downPayment.numberOfInstallments": params.downPaymentNumberOfInstallments,
        "paymentType": params.paymentType,
        "totalPayment.currency": params.currency,
        "totalPayment.amount": params.totalPaymentAmount,
        "totalPayment.VAT": params.totalPaymentVAT,
        "upFrontPayment.currency": params.currency,
        "upFrontPayment.amount": params.upFrontPaymentAmount,
        "upFrontPayment.VAT": params.upFrontPaymentVAT
    };
    return parameters;
}
function hardwarePaymentDTO(params) {
    const parameters = {
        "downPaymentAmount.currency": params.currency,
        "downPaymentAmount.amount": params.downPaymentAmount,
        "downPaymentAmount.VAT": params.downPaymentVAT,
        "numberOfInstallments": params.downPaymentNumberOfInstallments,
        "totalPaymentAmount.currency": params.currency,
        "totalPaymentAmount.amount": params.totalPaymentAmount,
        "totalPaymentAmount.VAT": params.totalPaymentVAT,
        "upFrontPaymentAmount.currency": params.currency,
        "upFrontPaymentAmount.amount": params.upFrontPaymentAmount,
        "upFrontPaymentAmount.VAT": params.upFrontPaymentVAT,
        "discountAmount.currency": params.currency,
        "discountAmount.amount": params.discountAmount,
        "discountAmount.VAT": params.discountVat,
        "paymentType": params.paymentType
    };
    return parameters;
}
function discountParameters(params) {
    const parameters = {
        "Discount.Currency": params.Currency,
        "Discount.Amount": params.Amount,
        "Discount.VAT": params.VAT,
    };
    return parameters;
}